/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Beneficiary details.
*/
export class AzureMarketplaceWebhookInputSubscriptionBeneficiary {
  /**
  * Email ID of the beneficiary.
  */
  'emailId'?: string;
  /**
  * Object ID of the beneficiary.
  */
  'objectId'?: string;
  /**
  * Tenant ID of the beneficiary.
  */
  'tenantId'?: string;
  /**
  * Beneficiary\'s PUID.
  */
  'puid'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "emailId",
      "baseName": "emailId",
      "type": "string",
      "format": "email"
    },
    {
      "name": "objectId",
      "baseName": "objectId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "puid",
      "baseName": "puid",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureMarketplaceWebhookInputSubscriptionBeneficiary.attributeTypeMap;
  }

  public constructor() {
  }
}

